/**
 * Build stamp so Cloudflare CI logs show which commit/config is live.
 * Bump when changing deploy wiring.
 */
export const CF_DEPLOY_STAMP = "prod-hardening-v16";

